import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';


import AssistantBox from './AssistantBox.js';


import Countdown from '../Countdown.js';


export default class Assistant extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        currentPosition: true
    }
  }


  componentDidMount() {
    this.interval = setInterval(() => {


      this.setState({
      
        currentPosition: this.props.getPos(this)
  
      })


    }, 500);
  }
componentWillUnmount() {
    clearInterval(this.interval);
  }


  render() {



    //handle the click on one of the buttons
    const handleClick = (e) => {

      //if the id value of the button and compare to the correct answer
      if( parseInt(e.target.getAttribute("value")) == this.props.correct_answer)
      { 
        this.props.setResult(true, this)
      }
      else
      {
        this.props.setResult(false, this)
      }





    };



    var assistantBoxes = []


  
    if(this.state.currentPosition <= 0)
    {
      assistantBoxes = [   
        
        <AssistantBox
            number={1}
            side="left"
            type="truth"
            questions={[

                ["Which button is opt out?", "The BLUE one"],
                //["Which button is not opt out?",  "The WHITE one"],
                ["What would the other assistant tell me to do?", "They'd tell you it's the WHITE one"],
                ["Why is this so difficult?", "Because you are only human"]
            ]}
        
        ></AssistantBox>,

        
        <AssistantBox 
            number={2}
            side="right"
            type="liar"
            questions={[

                ["Which button is opt out?", "The WHITE one"],
                //["Which button is not opt out?",  "The BLUE one"],
                ["What would the other assistant tell me to do?", "They'd tell you it's the WHITE one"],
                ["I am stuck, help!", "OK, I will"]
            ]}

        ></AssistantBox>]
    }

    



   

    return (


        
        <PopupBox extras={assistantBoxes} position={this.props.position} getPos={this.props.getPos} question={this}>

        
          <Countdown time_allowed={1190} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

        
      
              
          <h2 className="text-danger">{this.props.question}</h2>


          <br></br>

          <div className="d-flex justify-content-center">
          <ButtonToolbar>
              <Button value="0" onMouseDown={handleClick} className="mr-3" variant={this.props.color0} size="lg">Click</Button>  
              <Button value="1" onMouseDown={handleClick} className="mr-3" variant={this.props.color1} size="lg">Click</Button>
          </ButtonToolbar>
          </div>


        

        </PopupBox>
       

       
     

    );

  }
}
